import { RadioQuestion } from 'app/ui/components/radio-questions-list/RadioQuestionsList';

export const PRE_CONSTRUCTION: RadioQuestion[] = [
  {
    id: 'preSiteStarted',
    title: 'Has the site started any land-disturbing activity?',
    subtitle: '',
    state: null,
  },
  {
    id: 'preQualifiedPersonResponsible',
    title: 'Is a qualified Person responsible for the ESCP required?',
    subtitle: '',
    state: null,
    childrenTriggerValue: 'yes',
    children: [
      {
        id: 'preQualifiedPersonOnSite',
        title: 'Are they on site or available?',
        subtitle: '',
        state: null,
      },
    ],
  },
  {
    id: 'prePermitsPosted',
    title: 'Are the appropriate permits posted?',
    subtitle: '',
    state: null,
  },
  {
    id: 'preErosionControlsOkToInstall',
    title: 'Are the erosion and sediment control best practices as described on the approved plan ok to install?',
    subtitle: '',
    state: null,
  },

  {
    id: 'preErosionSedimentControlPlanOnSite',
    title: 'Is the approved Erosion Sediment Control Plan (ESCP) on-site and accessible?',
    subtitle: '',
    state: null,
  },
  {
    id: 'preSiteConditionsMatchEscp',
    title: 'Do the current site conditions match the approved ESCP?',
    subtitle: '',
    state: null,
  },
  {
    id: 'preEscpRevisionsNeeded',
    title: 'Does the ESCP require revisions?',
    subtitle: '',
    state: null,
  },
  {
    id: 'preEscpDewateringPlan',
    title: 'Does the ESCP include a plan for dewatering groundwater and stormwater?',
    subtitle: '',
    state: null,
    childrenTriggerValue: 'yes',
    children: [
      {
        id: 'preDewateringBmps',
        title: 'Are the dewatering BMPs on site?',
        subtitle: '',
        state: null,
      },
    ],
  },
  {
    id: 'preContaminatedSoil',
    title: 'Is there contaminated soil?',
    subtitle: '',
    state: null,
    childrenTriggerValue: 'yes',
    children: [
      {
        id: 'preContaminatedSoilPlan',
        title: 'Is there a plan for management of the contaminated soil?',
        subtitle: '',
        state: null,
        childrenTriggerValue: 'yes',
        children: [
          {
            id: 'preContaminatedSoilBmps',
            title: 'Are the BMPs on site to manage contaminated soil?',
            subtitle: '',
            state: null,
          },
        ],
      },
    ],
  },
  {
    id: 'preTreeProtectionPlan',
    title: 'Is there a tree protection plan?',
    subtitle: '',
    state: null,
    childrenTriggerValue: 'yes',
    children: [
      {
        id: 'preTreeProtectionBmps',
        title: 'Are the tree protection BMPs on site?',
        subtitle: '',
        state: null,
      },
    ],
  },
  {
    id: 'preSiteApprovedForDisturbance',
    title: 'Is this site approved to begin land disturbance for installation of ESCP BMPs?',
    subtitle: '',
    state: null,
  },
  {
    id: 'preGradingExcavationBegin',
    title: 'Can general grading and excavation begin following ESCP BMP installation?',
    subtitle: '',
    state: null,
  },
];

export const PRE_CONSTRUCTION_FAIL_MATRIX = [];
export const PRE_CONSTRUCTION_FAIL_MESSAGE = '';

export const POST_CONSTRUCTION: RadioQuestion[] = [
  {
    id: 'postGradedAreasStabilized',
    title: 'Are all graded and disturbed areas fully stabilized as described by the approved ESCP?',
    subtitle: '',
    state: null,
  },

  {
    id: 'postTemporaryErosion',
    title: 'Are all temporary erosion and sediment control best practices described on the approved plan removed?',
    subtitle: '',
    state: null,
  },
  {
    id: 'postLandscapeStabilized',
    title: 'Are all landscape areas stabilized with plant material?',
    subtitle: '',
    state: null,
  },
  {
    id: 'postAdditionalInspectionNeeded',
    title: 'Is an additional inspection to document compliance with the approved plan needed?',
    subtitle: '',
    state: null,
  },
];

export const POST_CONSTRUCTION_FAIL_MATRIX = [false, false, false, true];
export const POST_CONSTRUCTION_FAIL_MESSAGE =
  'Based on your selected answers, the final result of the inspection is failed. Are  you sure you want to continue?';

export const COMPLIANCE: RadioQuestion[] = [
  {
    id: 'compAccordingScm',
    title:
      'Are all erosion and sediment control measures depicted on the approved plan installed according to the approved plan and the DOEE Erosion and Sediment Control Manual?',
    subtitle: '',
    state: null,
  },

  {
    id: 'compSignPosted',
    title:
      'Is a sign posted that notifies the public to contact DOEE in the event of erosion or other pollution according to 21 DCMR § 543.22.?',
    subtitle: '',
    state: null,
  },
  {
    id: 'compAdditionalInspection',
    title: 'Is an additional inspection to document compliance with the approved plan needed?',
    subtitle: '',
    state: null,
  },
];

export const COMPLIANCE_FAIL_MATRIX = [false, false, true];
export const COMPLIANCE_FAIL_MESSAGE =
  'Based on your selected answers, the final result of the inspection is failed. Are  you sure you want to continue?';
